import { forwardRef } from 'react';
import classNames from 'classnames';

import { CheckableCard, Tag, TagStyle, Text } from '@hh.ru/magritte-ui';

import { ProfessionDto } from 'src/types/profession';

import styles from './styles.less';

interface CardProfessionGraphProps {
    checked: boolean;
    profession: ProfessionDto;
    probability?: number;
    onChange?: () => void;
    readOnly?: boolean;
    sticky?: boolean;
    tagStyle?: TagStyle;
    'data-qa'?: string;
}

const CardProfessionGraph = forwardRef<HTMLDivElement, CardProfessionGraphProps>(
    ({ checked, onChange, probability, profession, sticky, tagStyle, readOnly, ...props }, ref) => {
        return (
            <div
                className={classNames(styles.professionCard, {
                    [styles.sticky]: sticky,
                })}
                ref={ref}
                {...props}
            >
                <CheckableCard
                    checked={checked}
                    type="checkbox"
                    toneHover={!!probability}
                    padding={16}
                    borderRadius={16}
                    onChange={onChange}
                    readOnly={readOnly}
                    flexible
                >
                    <div className={classNames(styles.content, { [styles.centerContent]: !probability })}>
                        {probability && (
                            <span className={styles.tag}>
                                {/* TODO: fix ts error after magritte-ui update */}
                                {/* @ts-expect-error */}
                                <Tag style={tagStyle}>{probability}%</Tag>
                            </span>
                        )}
                        <Text typography="paragraph-2-regular">{profession.name}</Text>
                    </div>
                </CheckableCard>
            </div>
        );
    }
);
export default CardProfessionGraph;
